export const GET_FEATURE_FILE_TYPES = "GET_FEATURE_FILE_TYPES"
export const GET_FEATURE_FILE_TYPES_FAIL = "GET_FEATURE_FILE_TYPES_FAIL"
export const GET_FEATURE_FILE_TYPES_SUCCESS = "GET_FEATURE_FILE_TYPES_SUCCESS"

export const ADD_NEW_FEATURE_FILE_TYPE = "ADD_NEW_FEATURE_FILE_TYPE"
export const ADD_FEATURE_FILE_TYPE_SUCCESS = "ADD_FEATURE_FILE_TYPE_SUCCESS"
export const ADD_FEATURE_FILE_TYPE_FAIL = "ADD_FEATURE_FILE_TYPE_FAIL"

export const UPDATE_FEATURE_FILE_TYPE = "UPDATE_FEATURE_FILE_TYPE"
export const UPDATE_FEATURE_FILE_TYPE_SUCCESS = "UPDATE_FEATURE_FILE_TYPE_SUCCESS"
export const UPDATE_FEATURE_FILE_TYPE_FAIL = "UPDATE_FEATURE_FILE_TYPE_FAIL"

export const DELETE_FEATURE_FILE_TYPE = "DELETE_FEATURE_FILE_TYPE"
export const DELETE_FEATURE_FILE_TYPE_SUCCESS = "DELETE_FEATURE_FILE_TYPE_SUCCESS"
export const DELETE_FEATURE_FILE_TYPE_FAIL = "DELETE_FEATURE_FILE_TYPE_FAIL"





